import { Link, useNavigate, useLocation } from 'react-router-dom';
import './header-other.css';

export default function HeaderOther({ title = "Delivery in 10 mins", description = "Fresh groceries at your doorstep" }) {
    const navigate = useNavigate();
    const location = useLocation();

    function back() {
        if (location.key !== 'default') {
            navigate(-1);
        } else {
            navigate('/');
        }
    }

    return (
        <>
            <div className='header-other-container'>
                <div className='left-header-section'>
                    <button className='arrow-back' onClick={back}>
                        <img
                            src='/icons/left-arrow.png'
                            alt='back-arrow'
                            className='back-icon'
                        />
                    </button>

                    <div className='header-title-section'>
                        <h2 className='header-title'>{title}</h2>
                        <p className='header-subtitle'>{description}</p>
                    </div>
                </div>

                <div className='right-header-other'>
                    <Link to='/search' className='icon-button'>
                        <img className='find-logo' src='/find.png' alt='search' />
                    </Link>

                    <Link to='/hamburger-menu' className='menu-button'>
                        <div className='open-icon'></div>
                        <div className='open-icon'></div>
                        <div className='open-icon'></div>
                    </Link>
                </div>
            </div>
            <div className='header-other-spacer' />
        </>
    );
}